export class ArgumentError extends Error {
    readonly name: string = "ArgumentError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
